import React from 'react';
import styled from '@emotion/styled';
import { MainText, SecondaryText } from '../../../components/UI/mobile/ui';
import moment from 'moment';

const DetailContainer = styled.div`
  @media (orientation: landscape) {
    margin-top: 2vw;
  }
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 6vw;
  }
  overflow-y: auto;
  @media (orientation: landscape) {
    & > *:not(:last-child) {
      margin-bottom: 2vw;
    }
  }
`;

const Detail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const BillDetail = ({ bill }) => {
  return (
    <DetailContainer>
      <Details>
        {bill.financeList.map((detail, i) => (
          <Detail key={i}>
            <MainText style={{ width: '60vw' }}>
              {`${detail.title}`}
              <SecondaryText>{moment(detail.createdTime).format('YYYY/MM/DD HH:mm')}</SecondaryText>
            </MainText>
            <MainText>＄{detail.money.toLocaleString()}元</MainText>
          </Detail>
        ))}
      </Details>
    </DetailContainer>
  );
};

export default BillDetail;
